import {
	getAccountCount,
	getAccountOrder
} from '@/api/asset';
export default {
		name: 'account',
		components: {},
		data() {
			return {
				totalList: [{
					num: '1500',
					text: '账户总额(贝壳币)',
				}, {
					num: '1500',
					text: '账户余额(贝壳币)',
				}, {
					num: '1500',
					text: '员工账户余额(贝壳币）',
				}, {
					num: '1500',
					text: '有余额账户数(人）',
				}],
				form: {
					startTimeStrYMD:'',
					endTimeStrYMD:'',
				},
				contentList:[{
					img:require('../../../assets/images/account_1.png'),
					title:'发放总额',
					num:'8000',
					unit:'贝壳币'
				},{
					img:require('../../../assets/images/account_2.png'),
					title:'回收额',
					num:'8000',
					unit:'贝壳币'
				},{
					img:require('../../../assets/images/account_3.png'),
					title:'员工购买订单',
					num:'8000',
					unit:'笔'
				},{
					img:require('../../../assets/images/account_4.png'),
					title:'员工购买GMV',
					num:'8000',
					unit:'贝壳币'
				},{
					img:require('../../../assets/images/account_5.png'),
					title:'公司集采GMV',
					num:'8000',
					unit:'贝壳币'
				},{
					img:require('../../../assets/images/account_6.png'),
					title:'公司集采订单',
					num:'8000',
					unit:'笔'
				}]
			}
		},
		created() {
			if(localStorage.menuName == undefined){
				this.$store.commit('setMenuName', '账户总览');
			}
			this.getAccountCount();
			this.getAccountOrder();
		},
		methods: {
			//统计账户
			getAccountCount(){
				getAccountCount().then(res=>{
					let result = res.data.data;
					this.totalList[0].num = result.totalAmount;
					this.totalList[1].num = result.leftAmount;
					this.totalList[2].num = result.userLeftTotalAmount;
					this.totalList[3].num = result.userLeftAmountUserNum;
				})
			},
			//根据时间统计
			getAccountOrder(){
				getAccountOrder(this.form).then(res=>{
					let result = res.data.data;
					this.contentList[0].num = result.totalDistributeAmount;
					this.contentList[1].num = result.reclaimAmount;
					this.contentList[2].num = result.userOrderNum;
					this.contentList[3].num = result.userOrderAmountTotal;
					this.contentList[4].num = result.businessOrderAmountTotal;
					this.contentList[5].num = result.businessOrderNum;
				})
			},
		}
	}